<template>
    <div class="search">
        <div class="head" :class="$iosHeight()">
            <SearchInput
                :searchVal='searchVal'
                @goBack='onBack'
                @searchVal='onSearch'
            />
        </div>
        <div class="heightDiv" :class="$iosHeightDiv2()"></div>
        <SearchHistory
            v-show="!searchVal"
            :searchListArray='searchListArray'
            :hotSearchArray='hotSearchArray'
            @onSearchVal='onSearch'
            @delClick='onDel'
        />
    </div>
</template>
<script>
import SearchInput from './component/searchInput'
import SearchHistory from './component/history'
import { hotSearch } from '../api/api'
import { clearCache } from '@/utils/index'
import { Dialog } from 'vant'
export default {
    name: 'search',
    components: {
        SearchInput,
        SearchHistory
    },
    data () {
        return {
            searchVal: '',
            searchList: [],
            searchBack: '',
            searchListArray: [], // 搜索历史
            hotSearchArray: [] // 热门搜索
        }
    },
    methods: {
        onBack () {
            this.$router.push({ path: this.searchBack })
        },
        onSearch (value) {
            this.$router.push({ path: '/b2b/search/result', query: { keyword: value } })
        },
        onDel () {
            if (!this.searchListArray.length) {
                return
            }
            Dialog.confirm({
                title: '',
                message: '确定删除全部历史记录？',
                confirmButtonText: '删除',
                confirmButtonColor: '#FF7A45',
                cancelButtonColor: '#FF7A45'
            }).then(() => {
                localStorage.removeItem('searchList')
                this.getSearchList()
            })
        },
        async getHotSearch () {
            const { data } = await hotSearch({})
            this.hotSearchArray = data
        },
        getSearchList () {
            let searchList = localStorage.getItem('searchList') ? JSON.parse(localStorage.getItem('searchList')) : []
            if (searchList.length) {
                this.searchListArray = Array.from(new Set(searchList)).slice(0, 10)
            } else {
                this.searchListArray = []
            }
        }
    },
    created () {
        clearCache('searchResult')
        this.searchBack = localStorage.getItem('searchBack')
        this.getSearchList()
        this.getHotSearch()
    }
}
</script>
<style lang='scss' scoped>
    .isIosHeight {
        height: 145px !important;
    }
    .isIosHeight2 {
        height: 192px !important;
    }
    .search{
        position: relative;
        background: #f5f5f5;
        font-size: 28px;
        height: 100%;
        overflow: hidden;
        .head{
            position: fixed;
            left: 0;
            right: 0;
            z-index: 999;
            background: #fff;
        }
    }
    /deep/ .van-dialog__message{
        padding-top: 100px !important;
        padding-bottom: 80px !important;
    }
</style>